import React, { useEffect, useState } from "react";
import { Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, TextareaAutosize } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Modal from "../common/modal/Modal";
import ButtonComponent from "../common/button/Button";
import TextInput from "../common/TextInput";
import Dropdown from "../common/Dropdown";
import menuAllData from "../../common/supportMenu.json";
import { submitTicketData } from "../../redux/actions/SupportTicket/SubmitTicket";
import { submitSupportTicketEndpoint } from "../../common/endpoints";
import { toast } from "react-toastify";
import { clearSelectedItem } from "../../redux/actions/SupportTicket/selectionSlice";

const TicketModal = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [selectedMenu, setSelectedMenu] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedFunction, setSelectedFunction] = useState("");
  const [selectedAssignedTo, setSelectedAssignedTo] = useState("");
  const [description, setDescription] = useState('');
  const [menuInitialized, setMenuInitialized] = useState(false);
  const [urgency, setUrgency] = useState(false);

  const [menuOptions, setMenuOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [functionOptions, setFunctionOptions] = useState([]);
  const [assignedToOptions, setAssignedToOptions] = useState([]);
  const [openBoxModal, setOpenBoxModal] = useState(false);
  const [selectedBoxDetails, setSelectedBoxDetails] = useState({});
  const reportTabSlice = useSelector(state => state?.tabSlice?.tabName);
  const userEmail = localStorage.getItem("data");
  const pageTit = localStorage.getItem('pageName');
  const procurementDivisionType = localStorage.getItem('procurementDivisionType')

  const contractSeqIds = props.selectedItem?.map(item => item?.contractSeqId);
  const runOutputSeqIds = props.selectedItem?.map(item => item?.runOutputSeqId);
  const contractHistorySeqIds = props.selectedItem?.map(item => item?.contractHistorySeqId);

  const currentPath = location.pathname;

  const priceTagIdDetails = props.selectedItem?.map(item => item?.priceTagId)
  const vendorNumberDetails = props.selectedItem?.map(item => item?.sapSupplierId)
  const plantNumberDetails = props.selectedItem?.map(item => item?.sapPlantId)
  const materialNumberDetails = props.selectedItem?.map(item => item?.sapMaterialNumber)
  const errorDetailDetails = props.selectedItem?.map(item => item?.errorDetails)
  const statusDetails = props.selectedItem?.map(item => item?.status)
  const contractSerialNoDetails = props.selectedItem?.map(item => item?.contractSerialNumber)
  const agreementNoDetails = props.selectedItem?.map(item => item?.agreementNumber)

  const getUniqueValues = (data = [], key) => {
    if (data?.length > 0) {
      const uniqueValues = [
        ...new Set(data?.map((item) => item[key]).filter(Boolean)),
      ];
      return uniqueValues?.map((value) => ({
        label: value,
        value: value,
        title: value,
      }));
    } else {
      return [];
    }
  };

  const handleSelectedItemsChange = (name, event) => {
    const value = event.target.value;

    if (name === "menu") {
      setSelectedMenu(value);
      setSelectedCategory("");
      setSelectedFunction("");
      setSelectedAssignedTo("");
      setFunctionOptions([]);
      setAssignedToOptions([]);
      dispatch(clearSelectedItem());

      const filteredCategories = menuAllData
        .filter((item) => item.menu === value)
        .map((item) => item.category);
      setCategoryOptions(
        getUniqueValues(
          filteredCategories.map((c) => ({ category: c })),
          "category"
        )
      );
    } else if (name === "category") {
      setSelectedCategory(value);
      setSelectedFunction("");
      setSelectedAssignedTo("");

      const filteredItems = menuAllData.filter(
        (item) => item.menu === selectedMenu && item.category === value
      );
      const functionList = filteredItems.map((item) => item.function);
      const assignedToList = filteredItems.map((item) => item.assignedTo);
      setFunctionOptions(
        getUniqueValues(
          functionList.map((f) => ({ function: f })),
          "function"
        )
      );
      const assignedToOptionsFiltered = getUniqueValues(
        assignedToList.map((a) => ({ assignedTo: a })),
        "assignedTo"
      );
      setAssignedToOptions(assignedToOptionsFiltered);
      if (assignedToOptionsFiltered.length > 0) {
        setSelectedAssignedTo(assignedToOptionsFiltered[0].value);
      }
    } else if (name === "function") {
      setSelectedFunction(value);
    } else if (name === "assignedTo") {
      setSelectedAssignedTo(value);
    }
  };

  useEffect(() => {
  if (!menuInitialized) {
    setSelectedCategory("");
    setSelectedFunction("");
    setSelectedAssignedTo("");
    setDescription("");
    setFunctionOptions([]);
    setAssignedToOptions([]);
    const uniqueMenus = getUniqueValues(menuAllData, "menu");
    setMenuOptions(uniqueMenus);

    const pathToMenuMap = {
      "/price-memo": "Price Memo",
      "/price-memo/data-errors": "Price Memo data errors",
      "/contracts": "Contracts",
      "/reportings": "Reporting",
      "/contract-maintenance": "Contract Maintenance",
      "/contract-maintenance/new-contract": "Contract Maintenance",
      "/contract-maintenance/update-contract": "Contract Maintenance",
      "/cm-reports": "Contract Maintenance Report",
      "/quota-maintenance": "Quota Maintenance",
      "/pricememo-maintenance": "Price Memo Maintenance",
      "/pricememo-management": (procurementDivisionType === "CEPG" && location.pathname === "/pricememo-management") ? "Price Memo Maintenance (Cepg)" : "Price Memo Maintenance (Packaging)",
      "/packaging-viewer-pricememo": (procurementDivisionType === "CEPG" && location.pathname === "/packaging-viewer-pricememo") ? "Price Memo Viewer (Cepg)" : "Price Memo Viewer (Packaging)"
    };

    const matchedMenu = pathToMenuMap[location.pathname];
    if (matchedMenu) {
      setSelectedMenu(matchedMenu);

      const filteredCategories = menuAllData
        .filter((item) => item.menu === matchedMenu)
        .map((item) => item.category);

      const categoryOpts = getUniqueValues(
        filteredCategories.map((c) => ({ category: c })),
        "category"
      );
      setCategoryOptions(categoryOpts);
    }

    // Set menuInitialized so default selection is only set once
    setMenuInitialized(true);
  }

  // Keep updating page title in localStorage
  if (location.pathname === "/price-memo") {
    localStorage.setItem("pageName", "Price Memo");
  } else if (location.pathname === "/price-memo/data-errors") {
    localStorage.setItem("pageName", "Price Memo data errors");
  } else if (location.pathname === "/contracts") {
    localStorage.setItem("pageName", "Contracts");
  } else if (location.pathname === "/reportings") {
    localStorage.setItem("pageName", "Reporting");
  } else if (location.pathname === "/contract-maintenance") {
    localStorage.setItem("pageName", "Contract Maintenance");
  } else if (location.pathname === "/cm-reports") {
    localStorage.setItem("pageName", "Contract Maintenance Report");
  } else if(location.pathname === "/quota-maintenance"){
    localStorage.setItem("pageName","Quota Maintenance");
  } else if (location.pathname === "/pricememo-management") {
    localStorage.setItem("pageName", (procurementDivisionType === "CEPG" && location.pathname === "/pricememo-management") ? "Price Memo Maintenance (Cepg)" : "Price Memo Maintenance (Packaging)");
  } else if (location.pathname === "/packaging-viewer-pricememo") {
    localStorage.setItem("pageName", (procurementDivisionType === "CEPG" && location.pathname === "/packaging-viewer-pricememo") ? "Price Memo Viewer (Cepg)" : "Price Memo Viewer (Packaging)");
  }

  setMenuInitialized(false);
}, [location.pathname, menuAllData, menuInitialized, procurementDivisionType]);

  const handleClickInside = (mappedData, name) => {
    setOpenBoxModal(true);
    setSelectedBoxDetails({ mappedData: mappedData, name: name })
  };

  const handleCloseBoxModel = () => {
    setOpenBoxModal(false);
    setSelectedBoxDetails({ mappedData: {} })
  };

  const submitTicketHandler = async () => {
    const outboundSeqIdData =
      pageTit === "Price Memo" ||
      pageTit === "Price Memo data errors" ||
      (pageTit === "Reporting" && reportTabSlice === "Price Memo")
        ? runOutputSeqIds
        : (pageTit === "Reporting" && reportTabSlice === "Contracts") ||
          pageTit === "Contract Maintenance Report"
        ? contractHistorySeqIds
        : pageTit === "Contracts" ||
          currentPath === "/contract-maintenance/new-contract" ||
          currentPath === "/contract-maintenance/update-contract"
        ? contractSeqIds
        : null;
    const reportTabData = (pageTit === "Reporting" && reportTabSlice === "Price Memo") ? "Price Memo" : (pageTit === "Reporting" && reportTabSlice === "Contracts") ? "Contracts" : "";
    const apiDetails = {
      userEmail: userEmail,
      userRemarks: description,
      pmType: procurementDivisionType,
      outboundIntSeqIds : outboundSeqIdData,
      reportingSubtab: reportTabData,
      category: selectedCategory,
      function: selectedFunction,
      assignedTo: selectedAssignedTo,
      title: pageTit,
      urgency: urgency,
    }
    try {
      const response = await dispatch(
        submitTicketData({
          dynamicEndpoint: `${submitSupportTicketEndpoint}`,
          params: {
            plant: localStorage.getItem("selectedCDPlantCode"),
          },
          data: apiDetails
        })
      );
      if (response?.meta?.requestStatus === "fulfilled") {
        console.log(response?.payload?.alIdentifier);
          toast.success(`Ticket Created Successfully. Please visit 'Ticket Summary' menu for more details`, {
            autoClose: 3000,
          });
          toast.info(`AL Identifier: ${response?.payload?.alIdentifier}`, {
            autoClose: 7000,
            position: "bottom-center",
          });
          props.handleClose();
          setSelectedCategory("");
          setSelectedFunction("");
          setSelectedAssignedTo("");
          setDescription("");
          setUrgency(false);
      } else {
        toast.error(response?.payload?.errorMessage, {
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("API error:", error);
    }
  }

  const renderBoxItems = (mappedData, name) => {
      const isDisabled = !mappedData || mappedData?.length === 0;
      // const filteredData = (mappedData || []).filter(option => option !== null && option !== '');
      return <div>
        <Box
          onClick={!isDisabled ? () => handleClickInside(mappedData, name) : undefined}
          style={{
            height: "40px",
            marginTop: "5px",
            width: "180px",
            display: 'flex',
            overflowY: "auto",
            flexWrap: "wrap",
            gap: "4px",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            transition: "all 0.3s ease",
            cursor: isDisabled ? "default" : "pointer",
            backgroundColor: isDisabled ? "#f0f0f0" : "white",
            opacity: isDisabled ? 0.6 : 1,
          }}
        >
          {mappedData?.map((option, index) => (
            <Chip
              label={option}
              key={index}
            />
          ))}
        </Box>
        
      </div>
    }

  return (
    <Modal
      open={props.showModal}
      handleClose={props.handleClose}
      title={props.title}
      fullWidth={true}
      maxWidth="md"
      content={
        <>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label className="label-position" htmlFor="hierarchy">
                Menu
              </label>
              <Dropdown
                maxWidth="100%"
                label="Menu"
                value={selectedMenu || ""}
                name="menu"
                options={menuOptions}
                handleChange={(event) =>
                  handleSelectedItemsChange("menu", event)
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label className="label-position" htmlFor="hierarchy">
                Category
              </label>
              <Dropdown
                maxWidth="100%"
                label="Category"
                value={selectedCategory || ""}
                name="category"
                options={categoryOptions}
                handleChange={(event) =>
                  handleSelectedItemsChange("category", event)
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label className="label-position" htmlFor="hierarchy">
                Function
              </label>
              <Dropdown
                maxWidth="100%"
                label="Function"
                value={selectedFunction || ""}
                name="function"
                options={functionOptions}
                handleChange={(event) =>
                  handleSelectedItemsChange("function", event)
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label className="label-position" htmlFor="hierarchy">
                Assigned to
              </label>
              <Dropdown
                maxWidth="100%"
                label="Assigned to"
                value={selectedAssignedTo || ""}
                name="assignedTo"
                options={assignedToOptions}
                handleChange={(event) =>
                  handleSelectedItemsChange("assignedTo", event)
                }
              />
            </Grid>
          </Grid>
          { currentPath === "/price-memo" || (currentPath === "/reportings" && reportTabSlice === "Price Memo") ?
          <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Price Tag Id
              </label>
              {renderBoxItems(priceTagIdDetails, "Price Tag Id")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Vendor Number
              </label>
              {renderBoxItems(vendorNumberDetails, "Vendor Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Plant Number
              </label>
              {renderBoxItems(plantNumberDetails, "Plant Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Material Number
              </label>
              {renderBoxItems(materialNumberDetails, "Material Number")}
            </Grid>
          </Grid> : 
            currentPath === "/price-memo/data-errors" ?
          <>
          <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Price Tag Id
              </label>
              {renderBoxItems(priceTagIdDetails, "Price Tag Id")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Vendor Number
              </label>
              {renderBoxItems(vendorNumberDetails, "Vendor Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Plant Number
              </label>
              {renderBoxItems(plantNumberDetails, "Plant Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Material Number
              </label>
              {renderBoxItems(materialNumberDetails, "Material Number")}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Status
              </label>
              {renderBoxItems(statusDetails, "Status")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Error Details
              </label>
              {renderBoxItems(errorDetailDetails, "Error Details")}
            </Grid>
          </Grid>
          </> :  
            currentPath === "/contracts" || currentPath === "/contract-maintenance/new-contract" || currentPath === "/contract-maintenance/update-contract" ?
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Contract Serial Number
              </label>
              {renderBoxItems(contractSerialNoDetails, "Contract Serial Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Agreement Number
              </label>
              {renderBoxItems(agreementNoDetails, "Agreement Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Error Details
              </label>
              {renderBoxItems(errorDetailDetails, "Error Details")}
            </Grid>
          </Grid> :
            currentPath === "/cm-reports" ?
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Contract Serial Number
              </label>
              {renderBoxItems(contractSerialNoDetails, "Contract Serial Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Agreement Number
              </label>
              {renderBoxItems(agreementNoDetails, "Agreement Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Error Details
              </label>
              {renderBoxItems(errorDetailDetails, "Error Details")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Status
              </label>
              {renderBoxItems(statusDetails, "Status")}
            </Grid>
          </Grid> :
            currentPath === "/reportings" && reportTabSlice === "Contracts" ?
          <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Contract Serial Number
              </label>
              {renderBoxItems(contractSerialNoDetails, "Contract Serial Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Agreement Number
              </label>
              {renderBoxItems(agreementNoDetails, "Agreement Number")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Error Details
              </label>
              {renderBoxItems(errorDetailDetails, "Error Details")}
            </Grid>
            <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
              <label className="label-position" htmlFor="hierarchy">
                Status
              </label>
              {renderBoxItems(statusDetails, "Status")}
            </Grid>
          </Grid> :
          ""
          }
          <Grid mt={2}>
            <TextareaAutosize
              minRows={6}
              placeholder="Issue Description"
              style={{ width: '100%' }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
          <Dialog open={openBoxModal} onClose={handleCloseBoxModel} className="dialogBoxModal_viewAll" key={selectedBoxDetails?.name}>
            <DialogTitle>{`${selectedBoxDetails?.name} (${selectedBoxDetails?.mappedData?.length})`}</DialogTitle>
            <DialogContent sx={{ maxHeight: "300px", overflowY: "auto" }}>
              {selectedBoxDetails?.mappedData?.length > 0 ? (
                selectedBoxDetails?.mappedData?.map((option, index) => (
                  <Chip
                    key={index}
                    label={option}
                    sx={{ 
                      margin: "4px",
                      whiteSpace: "normal",         // allow multiline
                      wordBreak: "break-word",      // break long words
                      maxWidth: "100%",             // don't overflow container
                      display: "inline-block",      // behave like block-level for wrapping
                      height: 'auto',
                      padding: '10px',
                      '.MuiChip-label': {
                        whiteSpace: 'normal !important',

                      },
                    }}
                  />
                ))
              ) : (
                <p>No items selected</p>
              )}
            </DialogContent>
            <DialogActions>
              <ButtonComponent onClick={handleCloseBoxModel} type="primary" label="Close" />
            </DialogActions>
          </Dialog>
        </>
      }
      action={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            margin: "15px 0",
          }}
        >
          <div style={{display: 'flex', gap: '20px', alignItems: 'center'}}>
            <TextInput
              label="Initiator"
              value={props.userEmail}
              disabled={true}
            />
            <FormControlLabel control={<Checkbox checked={urgency} onChange={() => setUrgency(!urgency)} />} label="Urgent" />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "170px",
              alignItems: "center",
            }}
          >
            <ButtonComponent
              maxWidth="150px"
              label="Cancel"
              bgColor="white"
              color="black"
              onClick={props.handleClose}
            />
            <ButtonComponent
              maxWidth="150px"
              label="Submit"
              bgColor="black"
              color="white"
              onClick={submitTicketHandler}
            />
          </div>
        </div>
      }
    />
  );
};

export default TicketModal;